import { alertV3Reducer } from "./alerts-v3/reducers";
import { contentFoldersReducer } from "./content-folders/reducers";
import { contentGroupsReducer } from "./content-groups/reducers";
import { deploymentsReducer } from "./deployments";
import { scheduledDeploymentsReducer } from "./scheduled-deployments";
import { strategiesReducer } from "./strategies";

// Define the application store.
const appReducers = {
  alertsV3: alertV3Reducer,
  contentFolders: contentFoldersReducer,
  contentGroups: contentGroupsReducer,
  deployments: deploymentsReducer,
  scheduledDeployments: scheduledDeploymentsReducer,
  strategies: strategiesReducer,
};

export { appReducers };
